(function () {
  const selectors = {
    root: '[data-pako-custom-checkout]',
    cartJson: '[data-pako-checkout-cart]',
    form: '[data-pako-checkout-form]',
    deliveryOption: '[data-pako-delivery-option]',
    deliveryPanel: '[data-pako-delivery-panel]',
    novaTypeOption: '[data-pako-nova-type-option]',
    paymentOption: '[data-pako-payment-option]',
    pickup: '[data-pako-pickup-card]',
    status: '[data-pako-checkout-status]',
    subtotal: '[data-pako-subtotal]',
    discount: '[data-pako-discount]',
    discountRow: '[data-pako-discount-row]',
    shipping: '[data-pako-shipping]',
    total: '[data-pako-total]',
    cityInput: '[data-pako-city-input]',
    cityResults: '[data-pako-city-results]',
    warehouseInput: '[data-pako-warehouse-input]',
    warehouseResults: '[data-pako-warehouse-results]',
    warehouseLabel: '[data-pako-warehouse-label]',
    pointGroup: '[data-pako-nova-point-group]',
    courierFields: '[data-pako-courier-fields]',
    streetInput: '[data-pako-street-input]',
    streetResults: '[data-pako-street-results]',
    buildingInput: '[data-pako-building-input]',
    apartmentInput: '[data-pako-apartment-input]',
    billingToggle: '[data-pako-billing-toggle]',
    billingPanel: '[data-pako-billing-panel]',
    discountInput: '[data-pako-discount-input]',
    discountButton: '[data-pako-discount-button]',
    discountCodes: '[data-pako-discount-codes]',
    discountRemove: '[data-pako-discount-remove]',
    summaryItems: '[data-pako-summary-items]',
    removeItem: '[data-pako-remove-item]',
    removeDialog: '[data-pako-remove-dialog]',
    removeText: '[data-pako-remove-text]',
    removeConfirm: '[data-pako-remove-confirm]',
    removeCancel: '[data-pako-remove-cancel]',
    submit: '[data-pako-submit]'
  };

  const stateByRoot = new WeakMap();
  const SHOPIFY_CART_TIMEOUT_MS = 8000;
  const SHOPIFY_CART_RETRY_DELAY_MS = 1800;
  let popupObserverStarted = false;
  let popupSuppressScheduled = false;

  function suppressThemePopups() {
    if (!document.querySelector(selectors.root)) return;

    if (!document.documentElement.classList.contains('pako-custom-checkout-page')) {
      document.documentElement.classList.add('pako-custom-checkout-page');
    }
    if (document.body && !document.body.classList.contains('pako-custom-checkout-page')) {
      document.body.classList.add('pako-custom-checkout-page');
    }
    if (document.body) {
      document.body.classList.remove('locked', 'scroll-padding-0');
      document.body.style.overflow = '';
      document.body.style.overscrollBehavior = 'auto';
      document.body.style.overscrollBehaviorY = 'auto';
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.width = '';
    }
    document.documentElement.style.overscrollBehavior = 'auto';
    document.documentElement.style.overscrollBehaviorY = 'auto';

    const bodyScrollLock = window.themeCore && window.themeCore.utils && window.themeCore.utils.bodyScrollLock;
    if (bodyScrollLock && typeof bodyScrollLock.clearAllBodyScrollLocks === 'function') {
      bodyScrollLock.clearAllBodyScrollLocks();
    }

    document
      .querySelectorAll('[data-js-overlay="NewsletterPopupToggle"], [id*="newsletter_popup"]')
      .forEach((node) => {
        ['is-active', 'active', 'open'].forEach((className) => {
          if (node.classList.contains(className)) node.classList.remove(className);
        });
        if (node.getAttribute('aria-hidden') !== 'true') node.setAttribute('aria-hidden', 'true');
        if (node.style.display !== 'none') node.style.display = 'none';
        if (node.style.pointerEvents !== 'none') node.style.pointerEvents = 'none';
      });
  }

  function scheduleSuppressThemePopups() {
    if (popupSuppressScheduled) return;
    popupSuppressScheduled = true;
    window.setTimeout(() => {
      popupSuppressScheduled = false;
      suppressThemePopups();
    }, 0);
  }

  function observeThemePopups() {
    if (popupObserverStarted || !document.body) return;
    popupObserverStarted = true;
    new MutationObserver(scheduleSuppressThemePopups).observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  function formatMoney(cents) {
    const value = Number(cents || 0) / 100;
    try {
      return new Intl.NumberFormat('uk-UA', {
        style: 'currency',
        currency: 'UAH',
        minimumFractionDigits: 2
      }).format(value);
    } catch (_) {
      return `₴${value.toFixed(2)}`;
    }
  }

  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function getCartItemTitle(item) {
    return item.product_title || item.title || item.variant_title || 'Товар';
  }

  function getCartItemImage(item) {
    const image = item.featured_image || item.image || null;
    const rawUrl = typeof image === 'string' ? image : (image && (image.url || image.src));
    if (!rawUrl) return '';

    try {
      const url = new URL(rawUrl, window.location.origin);
      if (!url.searchParams.has('width')) url.searchParams.set('width', '160');
      return url.href;
    } catch (_) {
      return String(rawUrl);
    }
  }

  function getCartItemVariantTitle(item) {
    const title = item.variant_title || '';
    return title && title !== 'Default Title' ? title : '';
  }

  function getCartSubtotal(cart, root) {
    const subtotal = Number(cart?.items_subtotal_price ?? cart?.original_total_price);
    if (Number.isFinite(subtotal)) return subtotal;

    const total = Number(cart?.total_price ?? root.dataset.total ?? root.dataset.subtotal ?? 0);
    const discount = Number(cart?.total_discount ?? root.dataset.discount ?? 0);
    return Math.max(0, total + discount);
  }

  function getCartTotal(cart, root) {
    const total = Number(cart?.total_price ?? root.dataset.total ?? 0);
    if (Number.isFinite(total)) return total;
    return Math.max(0, getCartSubtotal(cart, root) - Number(cart?.total_discount ?? root.dataset.discount ?? 0));
  }

  function getAppliedDiscountCodes(cart) {
    const codes = [];

    (cart?.cart_level_discount_applications || []).forEach((discount) => {
      const title = discount?.title || discount?.code;
      if (discount?.type === 'discount_code' && title) codes.push(String(title));
    });

    (cart?.items || []).forEach((item) => {
      (item.line_level_discount_allocations || []).forEach((allocation) => {
        const discount = allocation.discount_application || allocation.discountApplication || {};
        const title = discount.title || discount.code;
        if (discount.type === 'discount_code' && title) codes.push(String(title));
      });
    });

    return [...new Set(codes)];
  }

  function discountCodeEquals(left, right) {
    return String(left || '').trim().toLowerCase() === String(right || '').trim().toLowerCase();
  }

  function getRouteRoot() {
    const route = window.Shopify && window.Shopify.routes && window.Shopify.routes.root;
    return typeof route === 'string' && route ? route : '/';
  }

  function normalizeBaseUrl(value) {
    return String(value || '').trim().replace(/\/+$/, '');
  }

  function getBackendUrl(root) {
    return normalizeBaseUrl(root.dataset.pakoCheckoutBackendUrl || '');
  }

  function parseCart(root) {
    const script = root.querySelector(selectors.cartJson);
    if (!script) return null;

    try {
      return JSON.parse(script.textContent || '{}');
    } catch (_) {
      return null;
    }
  }

  function getState(root) {
    if (!stateByRoot.has(root)) {
      stateByRoot.set(root, {
        cart: parseCart(root),
        healthOk: null,
        quote: null,
        quoteInFlight: false,
        quoteRequestId: 0,
        quoteTimer: null,
        city: null,
        warehouse: null,
        street: null,
        pendingRemoval: null,
        removeTrigger: null,
        discountInFlight: false,
        submitInFlight: false
      });
    }

    return stateByRoot.get(root);
  }

  function getSelectedValue(root, name, fallback) {
    const checked = root.querySelector(`input[name="${name}"]:checked`);
    return checked ? checked.value : fallback;
  }

  function getSelectedDelivery(root) {
    return getSelectedValue(root, 'deliveryMethod', 'nova_poshta');
  }

  function getSelectedNovaType(root) {
    return getSelectedValue(root, 'novaDeliveryType', 'branch');
  }

  function getSelectedPayment(root) {
    return getSelectedValue(root, 'paymentMethod', 'liqpay_online');
  }

  function setStatus(root, message, isError) {
    const status = root.querySelector(selectors.status);
    if (!status) return;

    status.hidden = !message;
    status.textContent = message || '';
    status.classList.toggle('is-error', Boolean(isError));
  }

  function getAutocompleteErrorMessage(error, fallback) {
    if (isNovaTransientBackendError(error)) {
      return 'Нова Пошта зараз оновлює довідник. Якщо потрібний пункт уже вибраний, можна продовжити оформлення.';
    }
    const message = String(error && error.message ? error.message : '').trim();
    if (!message || message === 'Не вдалося обробити custom checkout.') {
      return fallback;
    }
    return message;
  }

  function isNovaTransientBackendError(error) {
    return error?.code === 'nova_poshta_rate_limited'
      || error?.code === 'nova_poshta_unavailable'
      || error?.status === 429
      || error?.status === 502
      || error?.status === 503
      || error?.status === 504;
  }

  function setSubmitDisabled(root, isDisabled) {
    const submit = root.querySelector(selectors.submit);
    if (submit) submit.disabled = Boolean(isDisabled);
  }

  function isHidden(node) {
    return Boolean(node.closest('.is-hidden') || node.hidden);
  }

  function getQuoteNumber(quote, key, fallback) {
    const value = Number(quote && quote[key]);
    return Number.isFinite(value) ? value : fallback;
  }

  function getNovaDeliveryText(root, quote) {
    if (getSelectedDelivery(root) === 'pickup') return 'Безкоштовно';
    if (!quote) return 'Розрахуємо після вибору міста';
    if (quote.freeShipping) return 'Безкоштовно';
    if (quote.deliveryPayerType === 'Recipient') return 'Оплата за тарифами Нової Пошти';
    if (quote.deliveryPriceStatus === 'ok' && Number(quote.shippingCents) > 0) return formatMoney(quote.shippingCents);
    if (quote.deliveryPriceStatus === 'pending') return 'Розрахуємо після вибору міста';
    return 'За тарифом Нової Пошти';
  }

  function getNovaOptionText(root, quote) {
    if (!quote || quote.deliveryMethod !== 'nova_poshta') return 'Розрахунок';
    if (quote.freeShipping) return 'Безкоштовно';
    if (quote.deliveryPayerType === 'Recipient') return 'За тарифами НП';
    if (quote.deliveryPriceStatus === 'ok' && Number(quote.shippingCents) > 0) return formatMoney(quote.shippingCents);
    if (quote.deliveryPriceStatus === 'pending') return 'Розрахунок';
    return 'За тарифом';
  }

  function updateNovaOptionPrice(root, quote) {
    const node = root.querySelector('[data-pako-nova-price]');
    if (node) node.textContent = getNovaOptionText(root, quote);
  }

  function updateTotals(root) {
    const state = getState(root);
    const cart = state.cart || parseCart(root) || {};
    const subtotal = getCartSubtotal(cart, root);
    const discount = Number(cart.total_discount ?? root.dataset.discount ?? 0);
    const cartTotal = getCartTotal(cart, root);
    const quote = state.quote;
    const shipping = getQuoteNumber(quote, 'shippingCents', 0);
    const total = getQuoteNumber(quote, 'totalCents', cartTotal + shipping);

    const subtotalNode = root.querySelector(selectors.subtotal);
    const discountNode = root.querySelector(selectors.discount);
    const discountRow = root.querySelector(selectors.discountRow);
    const shippingNode = root.querySelector(selectors.shipping);
    const totalNode = root.querySelector(selectors.total);

    root.dataset.subtotal = String(subtotal);
    root.dataset.discount = String(discount);
    root.dataset.total = String(cartTotal);

    if (subtotalNode) subtotalNode.textContent = formatMoney(subtotal);
    if (discountNode) discountNode.textContent = discount > 0 ? `-${formatMoney(discount)}` : formatMoney(0);
    if (discountRow) discountRow.hidden = discount <= 0;
    if (shippingNode) shippingNode.textContent = getNovaDeliveryText(root, quote);
    if (totalNode) totalNode.textContent = formatMoney(total);
    updateNovaOptionPrice(root, quote);
  }

  function renderDiscountCodes(root) {
    const state = getState(root);
    const container = root.querySelector(selectors.discountCodes);
    if (!container) return;

    const codes = getAppliedDiscountCodes(state.cart || parseCart(root) || {});
    container.hidden = codes.length === 0;
    container.innerHTML = codes.map((code) => `
      <div class="pako-checkout__discount-code" data-pako-discount-code="${escapeHtml(code)}">
        <span>Знижка за промокодом <strong>${escapeHtml(code)}</strong></span>
        <button class="pako-checkout__discount-remove focus-visible-outline" type="button" data-pako-discount-remove data-discount-code="${escapeHtml(code)}" aria-label="Видалити промокод ${escapeHtml(code)}">
          <svg class="icon" aria-hidden="true" focusable="false" width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M10.5 3.5L3.5 10.5M3.5 3.5L10.5 10.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
          </svg>
        </button>
      </div>
    `).join('');
  }

  function renderSummaryItems(root) {
    const state = getState(root);
    const container = root.querySelector(selectors.summaryItems);
    const items = state.cart && Array.isArray(state.cart.items) ? state.cart.items : [];
    if (!container) return;

    container.innerHTML = items.map((item) => {
      const title = getCartItemTitle(item);
      const variantTitle = getCartItemVariantTitle(item);
      const imageUrl = getCartItemImage(item);
      const itemUrl = item.url || '#';
      const itemKey = item.key || '';
      const quantity = Number(item.quantity || 0);
      const linePrice = Number(item.final_line_price ?? item.line_price ?? 0);

      return `
        <div class="pako-checkout__summary-item" data-pako-summary-item data-item-key="${escapeHtml(itemKey)}" data-line-price="${linePrice}">
          <a class="pako-checkout__summary-image" href="${escapeHtml(itemUrl)}" aria-label="${escapeHtml(title)}">
            ${imageUrl ? `<img src="${escapeHtml(imageUrl)}" alt="${escapeHtml(title)}" width="80" height="80" loading="lazy">` : ''}
            <span class="pako-checkout__summary-quantity">${quantity}</span>
          </a>
          <div class="pako-checkout__summary-info">
            <a class="pako-checkout__summary-name" href="${escapeHtml(itemUrl)}">${escapeHtml(title)}</a>
            ${variantTitle ? `<span class="pako-checkout__summary-variant">${escapeHtml(variantTitle)}</span>` : ''}
          </div>
          <div class="pako-checkout__summary-actions">
            <div class="pako-checkout__summary-price">${formatMoney(linePrice)}</div>
            <button class="pako-checkout__summary-remove focus-visible-outline" type="button" data-pako-remove-item data-item-key="${escapeHtml(itemKey)}" data-item-title="${escapeHtml(title)}" aria-label="Видалити ${escapeHtml(title)}">
              <svg class="icon" aria-hidden="true" focusable="false" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M9 3H15L16 5H21V6.5H19.5L18.5 21H5.5L4.5 6.5H3V5H8L9 3ZM10 5H14L13.5 4.5H10.5L10 5ZM6 6.5L6.86 19.5H17.14L18 6.5H6ZM9 9H10.5V17H9V9ZM13.5 9H15V17H13.5V9Z" fill="currentColor"/>
              </svg>
            </button>
          </div>
        </div>
      `;
    }).join('');
  }

  function updatePickupCards(root) {
    root.querySelectorAll(selectors.pickup).forEach((card) => {
      const input = card.querySelector('input[name="pickupLocation"]');
      card.classList.toggle('is-selected', Boolean(input && input.checked));
    });
  }

  function updateNovaType(root) {
    const state = getState(root);
    const type = getSelectedNovaType(root);
    const isCourier = type === 'courier';
    const pointGroup = root.querySelector(selectors.pointGroup);
    const courierFields = root.querySelector(selectors.courierFields);
    const warehouseLabel = root.querySelector(selectors.warehouseLabel);
    const warehouseInput = root.querySelector(selectors.warehouseInput);

    root.querySelectorAll(selectors.novaTypeOption).forEach((option) => {
      const input = option.querySelector('input[name="novaDeliveryType"]');
      option.classList.toggle('is-selected', Boolean(input && input.value === type));
    });

    if (pointGroup) pointGroup.classList.toggle('is-hidden', isCourier);
    if (courierFields) courierFields.classList.toggle('is-hidden', !isCourier);
    if (warehouseLabel) warehouseLabel.textContent = type === 'postomat' ? 'Поштомат' : 'Відділення';
    if (warehouseInput) {
      warehouseInput.required = !isCourier;
      warehouseInput.placeholder = type === 'postomat' ? ' ' : ' ';
    }

    const streetInput = root.querySelector(selectors.streetInput);
    const buildingInput = root.querySelector(selectors.buildingInput);
    if (streetInput) streetInput.required = isCourier;
    if (buildingInput) buildingInput.required = isCourier;

    state.warehouse = null;
    state.street = null;
    clearSuggestions(root.querySelector(selectors.warehouseResults));
    clearSuggestions(root.querySelector(selectors.streetResults));
    if (warehouseInput) warehouseInput.value = '';
    if (streetInput) streetInput.value = '';
    scheduleQuote(root);
  }

  function updatePayments(root) {
    const delivery = getSelectedDelivery(root);
    let selectedStillAvailable = false;

    root.querySelectorAll(selectors.paymentOption).forEach((option) => {
      const input = option.querySelector('input[name="paymentMethod"]');
      const allowed = String(option.dataset.allowedDeliveries || '')
        .split(',')
        .map((item) => item.trim())
        .includes(delivery);

      option.classList.toggle('is-hidden', !allowed);
      if (input) {
        input.disabled = !allowed;
        if (allowed && input.checked) selectedStillAvailable = true;
      }
    });

    if (!selectedStillAvailable) {
      const firstAllowed = root.querySelector(`${selectors.paymentOption}:not(.is-hidden) input[name="paymentMethod"]`);
      if (firstAllowed) firstAllowed.checked = true;
    }

    root.querySelectorAll(selectors.paymentOption).forEach((option) => {
      const input = option.querySelector('input[name="paymentMethod"]');
      option.classList.toggle('is-selected', Boolean(input && input.checked && !input.disabled));
    });
  }

  function updateDelivery(root) {
    const selected = getSelectedDelivery(root);

    root.querySelectorAll(selectors.deliveryOption).forEach((option) => {
      const input = option.querySelector('input[name="deliveryMethod"]');
      option.classList.toggle('is-selected', input && input.value === selected);
    });

    root.querySelectorAll(selectors.deliveryPanel).forEach((panel) => {
      panel.classList.toggle('is-hidden', panel.dataset.pakoDeliveryPanel !== selected);
    });

    updatePickupCards(root);
    updatePayments(root);
    updateTotals(root);
    scheduleQuote(root);
  }

  function updateBilling(root) {
    const toggle = root.querySelector(selectors.billingToggle);
    const panel = root.querySelector(selectors.billingPanel);
    const useSame = !toggle || toggle.checked;

    if (panel) panel.classList.toggle('is-hidden', useSame);
  }

  function clearSuggestions(container) {
    if (!container) return;
    container.hidden = true;
    container.innerHTML = '';
  }

  function renderSuggestions(container, items, onPick) {
    if (!container) return;
    container.innerHTML = '';

    if (!items.length) {
      container.hidden = true;
      return;
    }

    items.forEach((item) => {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'pako-checkout__suggestion';
      button.textContent = item.label || item.name || item.shortAddress || '';
      button.addEventListener('click', () => {
        clearSuggestions(container);
        onPick(item);
      });
      container.appendChild(button);
    });

    container.hidden = false;
  }

  function debounce(fn, delay) {
    let timer = null;
    return function debounced(...args) {
      window.clearTimeout(timer);
      timer = window.setTimeout(() => fn.apply(this, args), delay);
    };
  }

  function wait(ms) {
    return new Promise((resolve) => {
      window.setTimeout(resolve, ms);
    });
  }

  function makeHttpError(message, status) {
    const error = new Error(message);
    error.status = status;
    return error;
  }

  async function fetchWithTimeout(url, options = {}, timeoutMs = SHOPIFY_CART_TIMEOUT_MS) {
    const controller = new AbortController();
    const timeout = window.setTimeout(() => controller.abort(), timeoutMs);

    try {
      return await fetch(url, {
        ...options,
        signal: controller.signal
      });
    } catch (error) {
      if (error?.name === 'AbortError') {
        throw makeHttpError('Request timed out', 408);
      }
      throw error;
    } finally {
      window.clearTimeout(timeout);
    }
  }

  async function shopifyCartFetch(path, options = {}, { retry = true } = {}) {
    const url = `${getRouteRoot()}${path}`;
    const attempts = retry ? 2 : 1;
    let lastError = null;

    for (let attempt = 0; attempt < attempts; attempt += 1) {
      try {
        const response = await fetchWithTimeout(url, options);
        if (response.status !== 429 || attempt === attempts - 1) return response;
        lastError = makeHttpError('Shopify cart API rate limited', 429);
      } catch (error) {
        lastError = error;
        if (attempt === attempts - 1 || (error?.status && error.status !== 408)) throw error;
      }

      await wait(SHOPIFY_CART_RETRY_DELAY_MS);
    }

    throw lastError || makeHttpError('Shopify cart API request failed', 0);
  }

  function getShopifyCartErrorMessage(error, fallback) {
    if (error?.status === 429) {
      return 'Shopify тимчасово обмежив запити до кошика. Зачекайте кілька секунд і спробуйте ще раз.';
    }
    if (error?.status === 408) {
      return 'Shopify довго відповідає на оновлення кошика. Спробуйте ще раз за кілька секунд.';
    }
    return fallback;
  }

  async function backendJson(root, path, options) {
    const backendUrl = getBackendUrl(root);
    if (!backendUrl) throw new Error('Не задано backend URL custom checkout.');

    const response = await fetch(`${backendUrl}${path}`, {
      ...options,
      headers: {
        Accept: 'application/json',
        ...(options && options.headers ? options.headers : {})
      }
    });

    let payload = null;
    try {
      payload = await response.json();
    } catch (_) {
      payload = null;
    }

    if (!response.ok) {
      const error = new Error(payload?.message || `Backend error ${response.status}`);
      error.status = response.status;
      error.code = payload?.code || '';
      throw error;
    }

    return payload;
  }

  function buildQuotePayload(root) {
    const state = getState(root);
    const deliveryMethod = getSelectedDelivery(root);
    const novaType = getSelectedNovaType(root);
    const delivery = { method: deliveryMethod };

    if (deliveryMethod === 'nova_poshta') {
      delivery.novaType = novaType;
      if (state.city) delivery.city = state.city;
      if ((novaType === 'branch' || novaType === 'postomat') && state.warehouse) {
        delivery.warehouse = state.warehouse;
      }
      if (novaType === 'courier') {
        const buildingInput = root.querySelector(selectors.buildingInput);
        const apartmentInput = root.querySelector(selectors.apartmentInput);
        delivery.courier = {
          street: state.street,
          building: String(buildingInput?.value || '').trim(),
          apartment: String(apartmentInput?.value || '').trim()
        };
      }
    }

    if (deliveryMethod === 'pickup') {
      delivery.pickupLocation = getPickupLocation(root);
    }

    return {
      cart: state.cart || parseCart(root),
      delivery,
      deliveryMethod,
      novaDeliveryType: novaType
    };
  }

  async function requestQuote(root) {
    const state = getState(root);
    const requestId = state.quoteRequestId + 1;
    state.quoteRequestId = requestId;
    state.quoteInFlight = true;

    try {
      const payload = await backendJson(root, '/api/custom-checkout/quote', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(buildQuotePayload(root))
      });

      if (state.quoteRequestId !== requestId) return;
      state.quote = payload?.quote || null;
      updateTotals(root);
    } catch (_) {
      if (state.quoteRequestId !== requestId) return;
      state.quote = null;
      updateTotals(root);
    } finally {
      if (state.quoteRequestId === requestId) state.quoteInFlight = false;
    }
  }

  function scheduleQuote(root, delay = 180) {
    const state = getState(root);
    window.clearTimeout(state.quoteTimer);
    state.quoteTimer = window.setTimeout(() => requestQuote(root), delay);
  }

  async function checkBackendHealth(root) {
    const state = getState(root);
    try {
      const payload = await backendJson(root, '/api/custom-checkout/health');
      state.healthOk = payload?.status === 'ok' && payload?.ready === true;
      if (!state.healthOk) {
        setStatus(root, 'Custom checkout тимчасово недоступний. Спробуйте ще раз за кілька секунд.', true);
      }
    } catch (_) {
      state.healthOk = false;
      setStatus(root, 'Custom checkout backend недоступний. Спробуйте ще раз за кілька секунд.', true);
    }
  }

  async function refreshCart(root) {
    const state = getState(root);
    try {
      const response = await shopifyCartFetch('cart.js', {
        credentials: 'same-origin',
        headers: {
          Accept: 'application/json'
        }
      });

      if (!response.ok) return;

      const cart = await response.json();
      if (cart && Number.isFinite(Number(cart.total_price))) {
        state.cart = cart;
        state.quote = null;
        renderSummaryItems(root);
        renderDiscountCodes(root);
        updateTotals(root);
        scheduleQuote(root, 0);
      }
    } catch (_) {
      updateTotals(root);
      scheduleQuote(root, 0);
    }
  }

  async function clearCart() {
    try {
      await shopifyCartFetch('cart/clear.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          Accept: 'application/json'
        }
      });
    } catch (_) {
      // Order was already created; do not block customer redirect on cart cleanup.
    }
  }

  function getRemoveDialog(root) {
    return root.querySelector(selectors.removeDialog);
  }

  function setRemoveButtonsDisabled(root, isDisabled) {
    root.querySelectorAll(selectors.removeItem).forEach((button) => {
      button.disabled = Boolean(isDisabled);
    });
  }

  function openRemoveDialog(root, trigger) {
    const state = getState(root);
    const dialog = getRemoveDialog(root);
    if (!dialog || !trigger) return;

    const title = trigger.dataset.itemTitle || 'товар';
    state.pendingRemoval = {
      key: trigger.dataset.itemKey || '',
      title
    };
    state.removeTrigger = trigger;

    const text = dialog.querySelector(selectors.removeText);
    if (text) text.textContent = `Видалити "${title}" з кошика?`;

    dialog.hidden = false;
    dialog.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('pako-checkout-remove-open');

    const card = dialog.querySelector('.pako-checkout__remove-card');
    window.setTimeout(() => {
      if (card) card.focus({ preventScroll: true });
    }, 0);
  }

  function closeRemoveDialog(root) {
    const state = getState(root);
    const dialog = getRemoveDialog(root);
    if (!dialog) return;

    dialog.hidden = true;
    dialog.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('pako-checkout-remove-open');

    const trigger = state.removeTrigger;
    state.pendingRemoval = null;
    state.removeTrigger = null;
    if (trigger && typeof trigger.focus === 'function' && document.contains(trigger)) {
      trigger.focus({ preventScroll: true });
    }
  }

  async function removeCartItem(root) {
    const state = getState(root);
    const pending = state.pendingRemoval;
    if (!pending || !pending.key) return;

    const dialog = getRemoveDialog(root);
    const confirm = dialog ? dialog.querySelector(selectors.removeConfirm) : null;
    const cancelButtons = dialog ? dialog.querySelectorAll(selectors.removeCancel) : [];

    if (confirm) confirm.disabled = true;
    cancelButtons.forEach((button) => {
      button.disabled = true;
    });
    setRemoveButtonsDisabled(root, true);
    setStatus(root, 'Оновлюємо кошик...', false);

    try {
      const response = await shopifyCartFetch('cart/change.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          id: pending.key,
          quantity: 0
        })
      });

      if (!response.ok) {
        throw makeHttpError(`Cart change failed ${response.status}`, response.status);
      }

      const cart = await response.json();
      if (!cart || !Array.isArray(cart.items)) {
        throw new Error('Cart response is invalid.');
      }

      state.cart = cart;
      state.quote = null;
      renderSummaryItems(root);
      renderDiscountCodes(root);
      updateTotals(root);
      closeRemoveDialog(root);
      setStatus(root, '', false);

      if (cart.item_count === 0) {
        window.location.assign(`${getRouteRoot()}cart`);
        return;
      }

      scheduleQuote(root, 0);
    } catch (error) {
      setStatus(root, getShopifyCartErrorMessage(error, 'Не вдалося видалити товар з кошика. Спробуйте ще раз.'), true);
    } finally {
      if (confirm) confirm.disabled = false;
      cancelButtons.forEach((button) => {
        button.disabled = false;
      });
      setRemoveButtonsDisabled(root, false);
    }
  }

  function bindNovaAutocomplete(root) {
    const state = getState(root);
    const cityInput = root.querySelector(selectors.cityInput);
    const cityResults = root.querySelector(selectors.cityResults);
    const warehouseInput = root.querySelector(selectors.warehouseInput);
    const warehouseResults = root.querySelector(selectors.warehouseResults);
    const streetInput = root.querySelector(selectors.streetInput);
    const streetResults = root.querySelector(selectors.streetResults);

    if (cityInput) {
      cityInput.addEventListener('input', debounce(async () => {
        state.city = null;
        state.warehouse = null;
        state.street = null;
        if (warehouseInput) warehouseInput.value = '';
        if (streetInput) streetInput.value = '';
        scheduleQuote(root);

        const query = cityInput.value.trim();
        if (query.length < 2) {
          clearSuggestions(cityResults);
          return;
        }

        try {
          const payload = await backendJson(root, `/api/custom-checkout/nova/cities?q=${encodeURIComponent(query)}`);
          renderSuggestions(cityResults, payload.items || [], (item) => {
            state.city = item;
            cityInput.value = item.label;
            cityInput.classList.remove('error');
            scheduleQuote(root, 0);
            if (getSelectedNovaType(root) !== 'courier' && warehouseInput) warehouseInput.focus();
            if (getSelectedNovaType(root) === 'courier' && streetInput) streetInput.focus();
          });
        } catch (error) {
          clearSuggestions(cityResults);
          setStatus(root, getAutocompleteErrorMessage(error, 'Не вдалося отримати міста Нової Пошти.'), !isNovaTransientBackendError(error));
        }
      }, 450));
    }

    if (warehouseInput) {
      warehouseInput.addEventListener('input', debounce(async () => {
        state.warehouse = null;
        const query = warehouseInput.value.trim();
        const type = getSelectedNovaType(root);

        if (!state.city || type === 'courier') {
          clearSuggestions(warehouseResults);
          return;
        }
        const minQueryLength = /^\d+$/.test(query) ? 1 : 2;
        if (query.length < minQueryLength) {
          clearSuggestions(warehouseResults);
          return;
        }

        try {
          const payload = await backendJson(
            root,
            `/api/custom-checkout/nova/warehouses?cityRef=${encodeURIComponent(state.city.ref)}&type=${encodeURIComponent(type)}&q=${encodeURIComponent(query)}`
          );
          renderSuggestions(warehouseResults, payload.items || [], (item) => {
            state.warehouse = item;
            warehouseInput.value = item.label;
            warehouseInput.classList.remove('error');
            scheduleQuote(root, 0);
          });
        } catch (error) {
          clearSuggestions(warehouseResults);
          setStatus(root, getAutocompleteErrorMessage(error, 'Не вдалося отримати точки Нової Пошти.'), !isNovaTransientBackendError(error));
        }
      }, 450));
    }

    if (streetInput) {
      streetInput.addEventListener('input', debounce(async () => {
        state.street = null;
        const query = streetInput.value.trim();

        if (!state.city || query.length < 2) {
          clearSuggestions(streetResults);
          return;
        }

        try {
          const payload = await backendJson(
            root,
            `/api/custom-checkout/nova/streets?cityRef=${encodeURIComponent(state.city.ref)}&q=${encodeURIComponent(query)}`
          );
          renderSuggestions(streetResults, payload.items || [], (item) => {
            state.street = item;
            streetInput.value = item.label;
            streetInput.classList.remove('error');
            scheduleQuote(root, 0);
            const buildingInput = root.querySelector(selectors.buildingInput);
            if (buildingInput) buildingInput.focus();
          });
        } catch (error) {
          clearSuggestions(streetResults);
          setStatus(root, getAutocompleteErrorMessage(error, 'Не вдалося отримати вулиці Нової Пошти.'), !isNovaTransientBackendError(error));
        }
      }, 450));
    }

    const scheduleCourierQuote = debounce(() => {
      if (getSelectedDelivery(root) === 'nova_poshta' && getSelectedNovaType(root) === 'courier') {
        scheduleQuote(root, 0);
      }
    }, 450);
    const buildingInput = root.querySelector(selectors.buildingInput);
    const apartmentInput = root.querySelector(selectors.apartmentInput);
    if (buildingInput) buildingInput.addEventListener('input', scheduleCourierQuote);
    if (apartmentInput) apartmentInput.addEventListener('input', scheduleCourierQuote);
  }

  function getActiveRequiredFields(root) {
    return Array.from(root.querySelectorAll('[required]')).filter((field) => {
      if (field.disabled || isHidden(field)) return false;
      return true;
    });
  }

  function markInvalid(field, isInvalid) {
    if (!field) return;
    field.classList.toggle('error', Boolean(isInvalid));
  }

  function validatePhoneField(field) {
    const digits = String(field?.value || '').replace(/\D/g, '');
    return /^380\d{9}$/.test(digits) || /^0\d{9}$/.test(digits);
  }

  function requireSelectedNovaData(root) {
    const state = getState(root);
    const delivery = getSelectedDelivery(root);
    const type = getSelectedNovaType(root);
    let firstInvalid = null;

    if (delivery !== 'nova_poshta') return null;

    const cityInput = root.querySelector(selectors.cityInput);
    if (!state.city) {
      markInvalid(cityInput, true);
      firstInvalid = firstInvalid || cityInput;
    }

    if (type === 'branch' || type === 'postomat') {
      const warehouseInput = root.querySelector(selectors.warehouseInput);
      if (!state.warehouse) {
        markInvalid(warehouseInput, true);
        firstInvalid = firstInvalid || warehouseInput;
      }
    }

    if (type === 'courier') {
      const streetInput = root.querySelector(selectors.streetInput);
      const buildingInput = root.querySelector(selectors.buildingInput);
      if (!state.street) {
        markInvalid(streetInput, true);
        firstInvalid = firstInvalid || streetInput;
      }
      if (!String(buildingInput?.value || '').trim()) {
        markInvalid(buildingInput, true);
        firstInvalid = firstInvalid || buildingInput;
      }
    }

    return firstInvalid;
  }

  function requireBilling(root) {
    const toggle = root.querySelector(selectors.billingToggle);
    if (!toggle || toggle.checked) return null;

    const requiredNames = ['billingFirstName', 'billingLastName', 'billingPhone', 'billingCity', 'billingAddress1'];
    let firstInvalid = null;

    requiredNames.forEach((name) => {
      const field = root.querySelector(`[name="${name}"]`);
      const invalid = !String(field?.value || '').trim();
      markInvalid(field, invalid);
      if (invalid && !firstInvalid) firstInvalid = field;
    });

    return firstInvalid;
  }

  function validate(root) {
    const fields = getActiveRequiredFields(root);
    let firstInvalid = null;
    let firstInvalidMessage = '';

    fields.forEach((field) => {
      let invalid = !String(field.value || '').trim() || (typeof field.checkValidity === 'function' && !field.checkValidity());
      if (!invalid && (field.name === 'phone' || field.name === 'billingPhone')) {
        invalid = !validatePhoneField(field);
        if (invalid && !firstInvalidMessage) firstInvalidMessage = 'Вкажіть коректний український номер телефону.';
      }
      markInvalid(field, invalid);
      if (invalid && !firstInvalid) firstInvalid = field;
    });

    firstInvalid = firstInvalid || requireSelectedNovaData(root) || requireBilling(root);

    if (firstInvalid) {
      firstInvalid.focus({ preventScroll: false });
      setStatus(root, firstInvalidMessage || 'Заповніть обов’язкові поля перед продовженням.', true);
      return false;
    }

    setStatus(root, '', false);
    return true;
  }

  function getPickupLocation(root) {
    const checked = root.querySelector('input[name="pickupLocation"]:checked');
    const card = checked ? checked.closest(selectors.pickup) : null;
    return {
      id: checked?.value || '',
      title: card?.dataset.pickupTitle || '',
      address: card?.dataset.pickupAddress || ''
    };
  }

  function buildPayload(root) {
    const state = getState(root);
    const form = root.querySelector(selectors.form);
    const data = new FormData(form);
    const deliveryMethod = getSelectedDelivery(root);
    const novaType = getSelectedNovaType(root);
    const paymentMethod = getSelectedPayment(root);
    const sameBillingAddress = data.get('sameBillingAddress') === 'on';
    const delivery = { method: deliveryMethod };

    if (deliveryMethod === 'pickup') {
      delivery.pickupLocation = getPickupLocation(root);
    } else {
      delivery.novaType = novaType;
      delivery.city = state.city;
      if (novaType === 'branch' || novaType === 'postomat') {
        delivery.warehouse = state.warehouse;
      } else {
        delivery.courier = {
          street: state.street,
          building: String(data.get('novaBuilding') || '').trim(),
          apartment: String(data.get('novaApartment') || '').trim()
        };
      }
    }

    return {
      cart: state.cart || parseCart(root),
      contact: {
        email: String(data.get('email') || '').trim(),
        firstName: String(data.get('firstName') || '').trim(),
        lastName: String(data.get('lastName') || '').trim(),
        phone: String(data.get('phone') || '').trim()
      },
      delivery,
      payment: {
        method: paymentMethod
      },
      billing: {
        sameAsDelivery: sameBillingAddress,
        address: sameBillingAddress ? null : {
          firstName: String(data.get('billingFirstName') || '').trim(),
          lastName: String(data.get('billingLastName') || '').trim(),
          phone: String(data.get('billingPhone') || '').trim(),
          country: 'Ukraine',
          city: String(data.get('billingCity') || '').trim(),
          address1: String(data.get('billingAddress1') || '').trim(),
          address2: String(data.get('billingAddress2') || '').trim(),
          zip: String(data.get('billingZip') || '').trim()
        }
      },
      discountCode: String(data.get('discount') || '').trim()
    };
  }

  function setDiscountBusy(root, isBusy) {
    const state = getState(root);
    state.discountInFlight = !!isBusy;

    const input = root.querySelector(selectors.discountInput);
    const button = root.querySelector(selectors.discountButton);
    if (input) input.disabled = !!isBusy;
    if (button) button.disabled = !!isBusy;
    root.querySelectorAll(selectors.discountRemove).forEach((removeButton) => {
      removeButton.disabled = !!isBusy;
    });
  }

  async function updateCartDiscounts(root, codes) {
    const state = getState(root);
    const discount = codes.filter(Boolean).join(',');
    const response = await shopifyCartFetch('cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ discount })
    });

    if (!response.ok) {
      throw makeHttpError(`Cart discount update failed ${response.status}`, response.status);
    }

    const updatedCart = await response.json();
    if (!updatedCart || !Array.isArray(updatedCart.items)) {
      throw new Error('Cart discount response is invalid.');
    }

    let cart = updatedCart;
    try {
      const freshResponse = await shopifyCartFetch('cart.js', {
        credentials: 'same-origin',
        headers: {
          Accept: 'application/json'
        }
      });
      if (freshResponse.ok) {
        const freshCart = await freshResponse.json();
        if (freshCart && Array.isArray(freshCart.items)) cart = freshCart;
      }
    } catch (_) {
      // cart/update.js has already succeeded; keep its totals if the follow-up refresh fails.
    }

    state.cart = cart;
    state.quote = null;
    // Discount changes do not change cart lines; avoid flickering product rows.
    renderDiscountCodes(root);
    updateTotals(root);
    scheduleQuote(root, 0);
    return cart;
  }

  async function applyDiscount(root) {
    const state = getState(root);
    if (state.discountInFlight) return;

    const input = root.querySelector(selectors.discountInput);
    const code = String(input?.value || '').trim();
    if (!code) {
      setStatus(root, 'Введіть промокод.', true);
      return;
    }

    const currentCodes = getAppliedDiscountCodes(state.cart || parseCart(root) || {});
    if (currentCodes.some((currentCode) => discountCodeEquals(currentCode, code))) {
      if (input) input.value = '';
      renderDiscountCodes(root);
      setStatus(root, `Промокод ${code} уже застосовано.`, false);
      return;
    }

    setDiscountBusy(root, true);
    setStatus(root, 'Застосовуємо промокод...', false);

    try {
      const cart = await updateCartDiscounts(root, [...currentCodes, code]);
      const nextCodes = getAppliedDiscountCodes(cart);
      if (!nextCodes.some((currentCode) => discountCodeEquals(currentCode, code))) {
        setStatus(root, `Промокод ${code} не застосувався до цього кошика.`, true);
        return;
      }

      if (input) input.value = '';
      setStatus(root, `Промокод ${code} застосовано.`, false);
    } catch (error) {
      setStatus(root, getShopifyCartErrorMessage(error, 'Не вдалося застосувати промокод. Спробуйте ще раз.'), true);
    } finally {
      setDiscountBusy(root, false);
    }
  }

  async function removeDiscount(root, trigger) {
    const state = getState(root);
    if (state.discountInFlight) return;

    const code = String(trigger?.dataset.discountCode || '').trim();
    if (!code) return;

    const currentCodes = getAppliedDiscountCodes(state.cart || parseCart(root) || {});
    const nextCodes = currentCodes.filter((currentCode) => !discountCodeEquals(currentCode, code));

    setDiscountBusy(root, true);
    setStatus(root, 'Оновлюємо промокоди...', false);

    try {
      await updateCartDiscounts(root, nextCodes);
      setStatus(root, `Промокод ${code} видалено.`, false);
    } catch (error) {
      setStatus(root, getShopifyCartErrorMessage(error, 'Не вдалося видалити промокод. Спробуйте ще раз.'), true);
    } finally {
      setDiscountBusy(root, false);
    }
  }

  async function submit(root) {
    const state = getState(root);

    if (!validate(root)) return;

    if (state.healthOk === false) {
      setStatus(root, 'Custom checkout тимчасово недоступний. Спробуйте ще раз за кілька секунд.', true);
      return;
    }

    setSubmitDisabled(root, true);
    state.submitInFlight = true;
    setStatus(root, 'Створюємо замовлення...', false);

    try {
      await refreshCart(root);
      const payload = buildPayload(root);
      const response = await backendJson(root, '/api/custom-checkout/submit', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(payload)
      });

      if (response.status !== 'ok') {
        throw new Error(response.message || 'Не вдалося створити замовлення.');
      }

      await clearCart();

      const targetUrl = response.redirectUrl || response.orderStatusUrl;
      if (!targetUrl) {
        throw new Error('Не вдалося отримати посилання для завершення замовлення.');
      }
      window.location.assign(targetUrl);
    } catch (error) {
      setStatus(root, error.message || 'Не вдалося створити замовлення. Спробуйте ще раз.', true);
    } finally {
      state.submitInFlight = false;
      setSubmitDisabled(root, false);
    }
  }

  function bind(root) {
    const form = root.querySelector(selectors.form);

    getState(root);
    updateNovaType(root);
    updateDelivery(root);
    updateBilling(root);
    renderDiscountCodes(root);
    refreshCart(root);
    checkBackendHealth(root);
    bindNovaAutocomplete(root);

    root.addEventListener('click', (event) => {
      const removeButton = event.target.closest(selectors.removeItem);
      if (removeButton && root.contains(removeButton)) {
        event.preventDefault();
        openRemoveDialog(root, removeButton);
        return;
      }

      const discountRemoveButton = event.target.closest(selectors.discountRemove);
      if (discountRemoveButton && root.contains(discountRemoveButton)) {
        event.preventDefault();
        removeDiscount(root, discountRemoveButton);
        return;
      }

      const cancelButton = event.target.closest(selectors.removeCancel);
      if (cancelButton && root.contains(cancelButton)) {
        event.preventDefault();
        closeRemoveDialog(root);
      }
    });

    const removeConfirm = root.querySelector(selectors.removeConfirm);
    if (removeConfirm) {
      removeConfirm.addEventListener('click', (event) => {
        event.preventDefault();
        removeCartItem(root);
      });
    }

    root.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && !getRemoveDialog(root)?.hidden) {
        event.preventDefault();
        closeRemoveDialog(root);
      }
    });

    root.querySelectorAll('input[name="deliveryMethod"]').forEach((input) => {
      input.addEventListener('change', () => {
        setStatus(root, '', false);
        updateDelivery(root);
      });
    });

    root.querySelectorAll('input[name="novaDeliveryType"]').forEach((input) => {
      input.addEventListener('change', () => {
        setStatus(root, '', false);
        updateNovaType(root);
        updateDelivery(root);
      });
    });

    root.querySelectorAll('input[name="pickupLocation"]').forEach((input) => {
      input.addEventListener('change', () => {
        setStatus(root, '', false);
        updatePickupCards(root);
        scheduleQuote(root);
      });
    });

    root.querySelectorAll('input[name="paymentMethod"]').forEach((input) => {
      input.addEventListener('change', () => {
        updatePayments(root);
      });
    });

    const billingToggle = root.querySelector(selectors.billingToggle);
    if (billingToggle) {
      billingToggle.addEventListener('change', () => {
        updateBilling(root);
      });
    }

    root.querySelectorAll('input, select, textarea').forEach((field) => {
      field.addEventListener('input', () => {
        field.classList.remove('error');
      });
    });

    const discountButton = root.querySelector(selectors.discountButton);
    if (discountButton) {
      discountButton.addEventListener('click', (event) => {
        event.preventDefault();
        applyDiscount(root);
      });
    }

    const discountInput = root.querySelector(selectors.discountInput);
    if (discountInput) {
      discountInput.addEventListener('keydown', (event) => {
        if (event.key !== 'Enter') return;
        event.preventDefault();
        applyDiscount(root);
      });
    }

    if (form) {
      form.addEventListener('submit', (event) => {
        event.preventDefault();
        submit(root);
      });
    }
  }

  function init() {
    suppressThemePopups();
    observeThemePopups();
    document.querySelectorAll(selectors.root).forEach(bind);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
}());
